import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';
import Modal from '@iso/components/Feedback/Modal';

const ConfigureModalSettingWrapper = styled(Modal)`

  .btn-success{
    width:50%;
    height:auto;
    background-color: #5e8c53;
    border-color: #5e8c53;
    &:hover{
      opacity: 0.8;
    }
  }

  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  
 .group-icon{
    display: flex;
    p{
        margin-left: 5px;
    }
 }
 .ant-checkbox{
    bottom: 4px
 }
.weather-type{
    margin-bottom: 24px;
}
.normal-label{
    margin-bottom: 8px;
}
.ant-select-multiple{
    width: 100%;
}
.btn-success{
    background-color: #0B2A1B;
}
.alert-cust{
    font-size : 14px !important;
}
input#deviceTime, input#areaBufferValue{
  height:30px !important;
}
.device_time, .area_buffer {
  display:flex;
}
.device_time p, .area_buffer p{
  margin-right : 5px;
  padding-top : 5px;
}
.ant-card-small.active{
    border-color: #0B2A1B;
    background-color: #f6ffed;
    box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.2);
}
/* Five tabs (Property, Group, After Hours, Post Alarm, Emergency
   Response) don't fit in antd's default 32px inter-tab gutter at this
   modal's 535px width — clicking a tab on either edge scrolls the
   strip and clips the opposite tab. Tightening the gutter buys back
   ~64px (4 gaps), enough to fit all five with no scroll. */
.ant-tabs-tab + .ant-tabs-tab {
  margin-left: 16px !important;
}
`;

export default WithDirection(ConfigureModalSettingWrapper);